import { render, staticRenderFns } from "./AscPageTitle.vue?vue&type=template&id=6ddc98a3&"
import script from "./AscPageTitle.vue?vue&type=script&lang=js&"
export * from "./AscPageTitle.vue?vue&type=script&lang=js&"
import style0 from "./AscPageTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports